var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPump = function SvgPump(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path2",
    fill: "currentColor",
    d: "M8 0C3.556 0 0 3.556 0 8s3.556 8 8 8 8-3.556 8-8-3.556-8-8-8m0 1.333c3.646 0 6.667 3.021 6.667 6.667S11.646 14.667 8 14.667 1.333 11.646 1.333 8 4.354 1.333 8 1.333M6.528 2.417c-.174 0-.382.038-.584.083-.798.09-1.506.965-1.416 1.944.267 2.045 2.396 1.434 2.305 2.945.268-.445.723-.723 1.167-.723.354 0 .622.094.889.362 0 0 .246-4.622-2.361-4.611m5.444 4.166c-1.187.077-1.784 1.344-2.722.695.177.444.184.979-.083 1.333-.177.267-.455.549-.723.639 0 0 4.438 2.924 5.417-.278.268-.798-.083-1.778-.972-2.222a1.94 1.94 0 0 0-.917-.167M8 7.111A.89.89 0 0 0 7.111 8c0 .49.4.889.889.889s.889-.4.889-.889A.89.89 0 0 0 8 7.111m-1.333.611s-4.722 2.4-2.5 4.89c.534.62 1.618.815 2.416.194 1.601-1.244.09-2.851 1.334-3.473-.354 0-.816-.257-1.084-.61-.177-.268-.166-.647-.166-1"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPump);
export default ForwardRef;